module.exports = __webpack_public_path__ + "static/media/sing-about-me_im-dying-of-thirst.82a1cd9d.pdf";